var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "importDetailInformationTab",
      staticClass: "flex-column import-detail-information-tab"
    },
    [
      _c(
        "div",
        { staticClass: "information" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Informations")))]),
          _vm._v(" "),
          _c("ImportTag", {
            ref: "importTag",
            attrs: {
              label: _vm.labelTagImport,
              status: _vm.importDetail.status,
              size: "medium"
            }
          }),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Date :")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$filters.saasDateFormatted(
                        _vm.importDetail.created_at
                      )
                    ) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Utilisateur :")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getFullNameStaff(_vm.importDetail)) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Type d’import :")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.labelTypeImport) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Traitement :")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                ref: "labelDurationImport",
                staticClass: "typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.labelDurationImport) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Nombre total de lignes :")) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getTotalRows) +
                    "\n            "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Actions")))]),
        _vm._v(" "),
        _vm.isImportCancellable(_vm.importDetail)
          ? _c(
              "div",
              { staticClass: "line-action" },
              [
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "settings.import.detail.ImportDetailInformationTab.cancel_import"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__(
                      "settings.import.detail.ImportDetailInformationTab.cancel_import"
                    ),
                    type: "tertiary-destructive"
                  },
                  on: { click: _vm.onCancel }
                })
              ],
              1
            )
          : _vm.hasRevertAction
          ? _c(
              "div",
              { staticClass: "line-action" },
              [
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "settings.import.detail.ImportDetailInformationTab.cancel_import_and_restore_data_label"
                          )
                        ) +
                        "\n                "
                    ),
                    _vm.remainingHoursToRollback
                      ? _c("span", { staticClass: "gray-60" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.remainingHoursToRollback) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      "content-class": "tooltip-disable-btn",
                      disabled: _vm.isImportCanBeReverted(_vm.importDetail),
                      content: _vm.getRevertImportBtnLabel(_vm.importDetail)
                    }
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        disabled: !_vm.isImportCanBeReverted(_vm.importDetail),
                        label: _vm.$t.__(
                          "settings.import.detail.ImportDetailInformationTab.cancel_import_and_restore_data"
                        ),
                        type: "tertiary-destructive"
                      },
                      on: { click: _vm.onRevert }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "line-action" },
          [
            _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Télécharger le fichier que vous avez utilisé pour votre import"
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              {
                attrs: {
                  content: _vm.$t.__(
                    "settings.import.detail.ImportDetailInformationTab.download_import_file_disabled_tooltip"
                  ),
                  disabled: !_vm.isDownloadFileDisabled
                }
              },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__(
                      "settings.import.detail.ImportDetailInformationTab.download_import_file"
                    ),
                    type: "tertiary",
                    loading: _vm.isFileDownloading,
                    disabled: _vm.isDownloadFileDisabled
                  },
                  on: { click: _vm.onDownloadImportFile }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.isDownloadErrorFileButtonDisplayed
          ? _c(
              "div",
              { staticClass: "line-action" },
              [
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Télécharger le fichier des erreurs identifiées lors de votre import"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      "content-class": "tooltip-disable-btn",
                      disabled: _vm.canDownloadErrorFile,
                      content: _vm.$t.__(
                        "settings.import.detail.ImportDetailInformationTab.action_available_when_import_processing_completed"
                      )
                    }
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "settings.import.detail.ImportDetailInformationTab.download_error_file"
                        ),
                        type: "tertiary",
                        disabled: !_vm.canDownloadErrorFile
                      },
                      on: { click: _vm.onDownloadErrorFile }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }